import React from "react";
import onClickOutside from "react-onclickoutside";

import styles from "./MainDropdown.module.scss";
import { isMobile } from "helpers/Mobile";
export class DropdownFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      open: false,
    };
  }

  handleClick = (e) => {
    const open = !this.state.open;
    this.setState({
      open,
      focused: open,
    });
  };

  handleSelect = (e) => {
    let optionLabel = e.target.dataset.optionLabel
    let optionValue = e.target.id

    let selectedOptionIndex = this.props.options.findIndex((o) => (
      optionValue
        ? o.option === optionValue
        : o.label === optionLabel
    ));

    let selectedObject = this.props.options[selectedOptionIndex];

    this.setState({
      open: false,
      focused: false
    })
    this.props.handleSelection(selectedObject);
  };

  handleClickOutside() {
    this.setState({
      focused: false,
      open: false,
    });
  }

  // searchKey(e){
  //   const reg = new RegExp('^[A-Za-z0-9_-]*$')
  //   const letter = e.key
  //   if(letter.length === 1 && reg.test(letter)){
  //     console.log('leter')
  //     this.searchLetter(letter)
  //     this.highlightedItemPosition = this.renderTeams.findIndex(team => team.name.toLocaleLowerCase().startsWith(letter.toLocaleLowerCase()))
  //   }
  // }

  render() {
    const {
      options,
      placeholder,
      label,
      selectedOption = null,
      required,
      disabled,
      error
    } = this.props;

    return (
      <div className={
        styles["main-dropdown-container"] + (disabled ? ' ' + styles["disabled"] : "")
      }>
        <div
          className={
            styles["main-dropdown-input"] + (this.state.focused ? ' ' + styles["focused"] : "")
          }
          onClick={disabled ? null : this.handleClick}
        >
          {selectedOption && <div className={styles["main-dropdown-label"]}>{label}{"  "}{required ? '*' : null}</div>}
          <div className={styles["main-dropdown-label-inner"]}>
            {!selectedOption && (
              <div className={styles["main-dropdown-placeholder"]}>
                {placeholder} {"  "}
                {required ? '*' : null}
              </div>
            )}

            {selectedOption && (
              <div className={styles["main-dropdown-selection"]}>
                {selectedOption.label}
              </div>
            )}
            <i
              className={
                "icon-chevron " + styles["main-dropdown-chevron"] + (this.state.open ? ' ' + styles["open"] : "")
              }
            ></i>
          </div>
        </div>
        {this.state.open && (
          <div className={styles["main-dropdown-option-container"]}>
            <div className={styles["main-dropdown-option-divider"]}></div>
            <div className={styles["main-dropdown-option-wrapper"]}>
              {options.map((option, index) => {
                return (
                  <div
                    className={styles["main-dropdown-option"]}
                    key={index}
                    onClick={this.handleSelect}
                    data-option-label={option.label}
                    id={option?.option || ""}
                  >
                    {option.label}
                    {option?.tooltip && option.tooltip}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className={styles["main-input-error"]}>
          {error}
        </div>
      </div>
    );
  }
}

export default onClickOutside(DropdownFilter);
